import { useQuery } from '@tanstack/react-query';

type SimpleClient = {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress?: string | null;
};

type FamilyMemberDetections = {
  client: SimpleClient;
  detections: unknown[];
  isProcessed: boolean;
};

type FamilyFileDetections = {
  fileId: string;
  familyId: string;
  members: FamilyMemberDetections[];
};

type Options = { enabled?: boolean };

export function useFamilyFileDetections(
  familyId: string | undefined,
  fileId: string | undefined,
  { enabled = true }: Options = {},
) {
  const { data, isLoading } = useQuery<FamilyFileDetections>({
    queryKey: ['families', familyId, 'data-upload-files', fileId, 'detections'],
    enabled: enabled && !!familyId && !!fileId,
  });

  return { members: data?.members ?? [], isLoading };
}
